export const YEAR_OPTIONS = Array.from({ length: 100 }, (_, i) => (2022 - i).toString());

export const COUNTRY_CODE_OPTIONS = [
  'Korea (+82)',
  'Vietnam (+84)',
  'China (+86)',
  'USA, Canada (+1)',
  'Germany (+49)',

  'Afghanistan (+93)',
  'Albania (+355)',
  'Algeria (+213)',
  'American Samoa (+1)',
  'Andorra (+376)',
  'Angola (+244)',
  'Anguilla (+1)',
  'Antigua and Barbuda (+1)',
  'Argentina (+54)',
  'Armenia (+374)',
  'Australia (+61)',
  'Austria (+43)',
  'Azerbaijan (+994)',
  'Bahamas (+1)',
  'Bahrain (+973)',
  'Bangladesh (+880)',
  'Barbados (+1)',
  'Belarus (+375)',
  'Belgium (+32)',
  'Belize (+501)',
  'Benin (+229)',
  'Bermuda (+1)',
  'Bhutan (+975)',
  'Bolivia (+591)',
  'Bosnia and Herzegovina (+387)',
  'Botswana (+267)',
  'Brazil (+55)',
  'Brunei (+673)',
  'Bulgaria (+359)',
  'Burkina Faso (+226)',
  'Burundi (+257)',
  'Cambodia (+855)',
  'Cameroon (+237)',
  'Canada (+1)',
  'Cape Verde (+238)',
  'Cayman Islands (+1)',
  'Central African Republic (+236)',
  'Chad (+235)',
  'Chile (+56)',
  'Colombia (+57)',
  'Comoros (+269)',
  'Congo (+242)',
  'Congo, Democratic Republic (+243)',
  'Costa Rica (+506)',
  'Croatia (+385)',
  'Cuba (+53)',
  'Cyprus (+357)',
  'Czech Republic (+420)',
  'Denmark (+45)',
  'Djibouti (+253)',
  'Dominica (+1)',
  'Dominican Republic (+1)',
  'Ecuador (+593)',
  'Egypt (+20)',
  'El Salvador (+503)',
  'Equatorial Guinea (+240)',
  'Eritrea (+291)',
  'Estonia (+372)',
  'Ethiopia (+251)',
  'Fiji (+679)',
  'Finland (+358)',
  'France (+33)',
  'French Guiana (+594)',
  'Gabon (+241)',
  'Gambia (+220)',
  'Georgia (+995)',
  'Ghana (+233)',
  'Greece (+30)',
  'Greenland (+299)',
  'Grenada (+1)',
  'Guatemala (+502)',
  'Guinea (+224)',
  'Guinea-Bissau (+245)',
  'Guyana (+592)',
  'Haiti (+509)',
  'Honduras (+504)',
  'Hong Kong (+852)',
  'Hungary (+36)',
  'Iceland (+354)',
  'India (+91)',
  'Indonesia (+62)',
  'Iran (+98)',
  'Iraq (+964)',
  'Ireland (+353)',
  'Israel (+972)',
  'Italy (+39)',
  'Jamaica (+1)',
  'Japan (+81)',
  'Jordan (+962)',
  'Kazakhstan (+7)',
  'Kenya (+254)',
  'Kiribati (+686)',
  'Kuwait (+965)',
  'Kyrgyzstan (+996)',
  'Laos (+856)',
  'Latvia (+371)',
  'Lebanon (+961)',
  'Lesotho (+266)',
  'Liberia (+231)',
  'Libya (+218)',
  'Liechtenstein (+423)',
  'Lithuania (+370)',
  'Luxembourg (+352)',
  'Macao (+853)',
  'Macedonia (+389)',
  'Madagascar (+261)',
  'Malawi (+265)',
  'Malaysia (+60)',
  'Maldives (+960)',
  'Mali (+223)',
  'Malta (+356)',
  'Marshall Islands (+692)',
  'Mauritania (+222)',
  'Mauritius (+230)',
  'Mexico (+52)',
  'Micronesia (+691)',
  'Moldova (+373)',
  'Monaco (+377)',
  'Mongolia (+976)',
  'Montenegro (+382)',
  'Morocco (+212)',
  'Mozambique (+258)',
  'Myanmar (+95)',
  'Namibia (+264)',
  'Nauru (+674)',
  'Nepal (+977)',
  'Netherlands (+31)',
  'New Zealand (+64)',
  'Nicaragua (+505)',
  'Niger (+227)',
  'Nigeria (+234)',
  'North Korea (+850)',
  'Norway (+47)',
  'Oman (+968)',
  'Pakistan (+92)',
  'Palau (+680)',
  'Palestine (+970)',
  'Panama (+507)',
  'Papua New Guinea (+675)',
  'Paraguay (+595)',
  'Peru (+51)',
  'Philippines (+63)',
  'Poland (+48)',
  'Portugal (+351)',
  'Qatar (+974)',
  'Romania (+40)',
  'Russia (+7)',
  'Rwanda (+250)',
  'Saint Kitts and Nevis (+1)',
  'Saint Lucia (+1)',
  'Saint Vincent and the Grenadines (+1)',
  'Samoa (+685)',
  'San Marino (+378)',
  'Sao Tome and Principe (+239)',
  'Saudi Arabia (+966)',
  'Senegal (+221)',
  'Serbia (+381)',
  'Seychelles (+248)',
  'Sierra Leone (+232)',
  'Singapore (+65)',
  'Slovakia (+421)',
  'Slovenia (+386)',
  'Solomon Islands (+677)',
  'Somalia (+252)',
  'South Africa (+27)',
  'South Sudan (+211)',
  'Spain (+34)',
  'Sri Lanka (+94)',
  'Sudan (+249)',
  'Suriname (+597)',
  'Swaziland (+268)',
  'Sweden (+46)',
  'Switzerland (+41)',
  'Syria (+963)',
  'Taiwan (+886)',
  'Tajikistan (+992)',
  'Tanzania (+255)',
  'Thailand (+66)',
  'Timor-Leste (+670)',
  'Togo (+228)',
  'Tonga (+676)',
  'Trinidad and Tobago (+1)',
  'Tunisia (+216)',
  'Turkey (+90)',
  'Turkmenistan (+993)',
  'Tuvalu (+688)',
  'Uganda (+256)',
  'Ukraine (+380)',
  'United Arab Emirates (+971)',
  'United Kingdom (+44)',
  'Uruguay (+598)',
  'Uzbekistan (+998)',
  'Vanuatu (+678)',
  'Venezuela (+58)',
  'Yemen (+967)',
  'Zambia (+260)',
  'Zimbabwe (+263)',
];

export const NATIONALITY_OPTIONS = [
  'Korea, Republic of',
  'Vietnam',
  'China',
  'United States',
  'Germany',

  'Afghanistan',
  'Åland Islands',
  'Albania',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antarctica',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia',
  'Bonaire, Sint Eustatius and Saba',
  'Bosnia and Herzegovina',
  'Botswana',
  'Bouvet Island',
  'Brazil',
  'British Indian Ocean Territory',
  'Brunei Darussalam',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cape Verde',
  'Cayman Islands',
  'Central African Republic',
  'Chad',
  'Chile',
  'Christmas Island',
  'Cocos (Keeling) Islands',
  'Colombia',
  'Comoros',
  'Congo, Republic of the (Brazzaville)',
  'Congo, the Democratic Republic of the (Kinshasa)',
  'Cook Islands',
  'Costa Rica',
  "Côte d'Ivoire, Republic of",
  'Croatia',
  'Cuba',
  'Curaçao',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Ethiopia',
  'Falkland Islands (Islas Malvinas)',
  'Faroe Islands',
  'Fiji',
  'Finland',
  'France',
  'French Guiana',
  'French Polynesia',
  'French Southern and Antarctic Lands',
  'Gabon',
  'Gambia, The',
  'Georgia',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guernsey',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Heard Island and McDonald Islands',
  'Holy See (Vatican City)',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran, Islamic Republic of',
  'Iraq',
  'Ireland',
  'Isle of Man',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jersey',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  "Korea, Democratic People's Republic of",
  'Kosovo',
  'Kuwait',
  'Kyrgyzstan',
  'Laos',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macao',
  'Macedonia, Republic of',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Micronesia, Federated States of',
  'Moldova',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Niue',
  'Norfolk Island',
  'Northern Mariana Islands',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestine',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Pitcairn',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Réunion',
  'Romania',
  'Russian Federation',
  'Rwanda',
  'Saint Barthélemy',
  'Saint Helena, Ascension and Tristan da Cunha',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Martin',
  'Saint Pierre and Miquelon',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Sint Maarten (Dutch part)',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Georgia and South Sandwich Islands',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Eswatini',
  'Sweden',
  'Switzerland',
  'Syrian Arab Republic',
  'Taiwan',
  'Tajikistan',
  'Tanzania, United Republic of',
  'Thailand',
  'Timor-Leste',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks and Caicos Islands',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States Minor Outlying Islands',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela, Bolivarian Republic of',
  'Virgin Islands, British',
  'Virgin Islands, U.S.',
  'Wallis and Futuna',
  'Western Sahara',
  'Yemen',
  'Zambia',
  'Zimbabwe',
];

export const OCCUPATION_OPTIONS = [
  'Undergraduate Student',
  'Graduate Student',
  'Exchange Student',
  'Education/Academic Research',
  'IT/Software/Engineering',
  'Manufacture/Agriculture',
  'Arts/Design',
  'Finance/Banking',
  'Public Service/Government',
  'Healthcare/Medical Service',
  'Business/Sales',
  'Legal/Consulting',
  'Others',
];

export const VISA_INFO_OPTIONS = [
  'Diplomatic/Official(A-1,A-2)',
  'Visa Exempted(B)',
  'Journalism/Religious Affairs(C-1, D-5, D-6)',
  'Short Term Visit(C-2, C-3)',
  'Study(D-2)',
  'Trainee(D-3,D-4)',
  'Intra-Company Transfer(D-7)',
  'Professional(C-4, D-1, D-8, D-9, D-10, E-1, E-2, E-3, E-4, E-5, E-6, E-7)',
  'Non-Professional(E-8, E-9, E-10)',
  'Working Holiday(H-1)',
  'Work and Visit(H-2)',
  'Familiy Visitor/Dependent Family(F-1, F-2, F-3)',
  'Overseas Korean(F-4)',
  'Permanent Residence(F-5)',
  'Marrige Migrant(F-6)',
  'Others(G-1)',
];

export const UNIV_LIST = [
  {
    title: 'Seoul National\nUniversity',
    url: '?originalWhere=SNU+University&whereType=UNIVERSITY&whereValue=SNU&source=univ_card',
    banner: '/images/optimized/univ/banner/snu1.webp',
    card: '/images/optimized/univ/card/snu.webp',
    link: 'https://buttercup-coral-e9a.notion.site/SNU-Local-Info-8e2dd6a65483456bb3afe31a3b7f246f?pvs=4',
  },
  {
    title: 'Soongsil\nUniversity',
    url: '?originalWhere=SSU+University&whereType=UNIVERSITY&whereValue=SSU&source=univ_card',
    banner: '/images/optimized/univ/banner/ssu1.webp',
    card: '/images/optimized/univ/card/ssu.webp',
    link: 'https://buttercup-coral-e9a.notion.site/Soongsil-Uni-Local-Info-a5ea3235b58e45f89eca12c25f6abe44?pvs=4',
  },
  {
    title: 'Chung-Ang\nUniversity',
    url: '?originalWhere=CAU+University&whereType=UNIVERSITY&whereValue=CAU&source=univ_card',
    banner: '/images/optimized/univ/banner/cau1.webp',
    card: '/images/optimized/univ/card/cau.webp',
    link: 'https://buttercup-coral-e9a.notion.site/CAU-Local-Info-c8e404a7b7774fe098a47ad0cd13fad1?pvs=4',
  },
  {
    title: 'Sungkyunkwan\nUniversity',
    url: '?originalWhere=SKKU+University&whereType=UNIVERSITY&whereValue=SKKU&source=univ_card',
    banner: '/images/optimized/univ/banner/skku1.webp',
    card: '/images/optimized/univ/card/skku.webp',
    link: 'https://buttercup-coral-e9a.notion.site/SKKU-Local-Info-9e7a7b270ec245138a327c76c91e6c83?pvs=4',
  },
  {
    title: 'KyungHee\nUniversity',
    url: '?originalWhere=KHU+University&whereType=UNIVERSITY&whereValue=KHU&source=univ_card',
    banner: '/images/optimized/univ/banner/kyunghee1.webp',
    card: '/images/optimized/univ/card/kyunghee.webp',
    link: 'https://buttercup-coral-e9a.notion.site/KyungHee-Univ-Local-Info-220c00e560868016b903c3d1989e08e6?source=copy_link',
  },

  {
    title: 'Korea\nUniversity',
    url: '?originalWhere=KOREA+University&whereType=UNIVERSITY&whereValue=KOREA&source=univ_card',
    banner: '/images/optimized/univ/banner/korea1.webp',
    card: '/images/optimized/univ/card/korea.webp',
    link: 'https://buttercup-coral-e9a.notion.site/Korea-Uni-Local-Info-f1c54a884d834c0e9e9e08e0e23c9866?pvs=4',
  },
  {
    title: 'HUFS',
    url: '?originalWhere=HUFS&whereType=UNIVERSITY&whereValue=HUFS&source=univ_card',
    banner: '/images/optimized/univ/banner/hufs1.webp',
    card: '/images/optimized/univ/card/hufs.webp',
    link: 'https://buttercup-coral-e9a.notion.site/HUFS-Local-Info-222c00e560868019958ae97aafd5c405?source=copy_link',
  },
  {
    title: 'Konkuk\nUniversity',
    url: '?originalWhere=KONKUK+University&whereType=UNIVERSITY&whereValue=KONKUK&source=univ_card',
    banner: '/images/optimized/univ/banner/konkuk1.webp',
    card: '/images/optimized/univ/card/konkuk.webp',
    link: '',
  },
  {
    title: 'Dongguk\nUniversity',
    url: '?originalWhere=DONGGUK+University&whereType=UNIVERSITY&whereValue=DONGGUK&source=univ_card',
    banner: '/images/optimized/univ/banner/dongguk1.webp',
    card: '/images/optimized/univ/card/dongguk.webp',
    link: 'https://buttercup-coral-e9a.notion.site/Dongguk-Uni-Local-Info-1dfc00e560868028b8cef114508cc1cb',
  },
  {
    title: 'Ewha\nUniversity',
    url: '?originalWhere=IHWA+University&whereType=UNIVERSITY&whereValue=EWHA&source=univ_card',
    banner: '/images/optimized/univ/banner/ewha1.webp',
    card: '/images/optimized/univ/card/ewha.webp',
    link: 'https://buttercup-coral-e9a.notion.site/Ehwa-W-Uni-Local-Info-1d9c00e560868068b9d8c3945c8af044',
  },
];

export const GENDER_OPTIONS = ['MALE', 'FEMALE'];

export const MONTH_OPTIONS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

export const DAY_OPTIONS_BY_MONTH_AND_YEAR = (month: string, year: string) => {
  const yearNum = parseInt(year) ?? 2000;
  switch (month) {
    case 'JAN':
    case 'MAR':
    case 'MAY':
    case 'JUL':
    case 'AUG':
    case 'OCT':
    case 'DEC':
      return Array.from({ length: 31 }, (_, i) => (i < 9 ? `0${i + 1}` : (i + 1).toString()));
    case 'APR':
    case 'JUN':
    case 'SEP':
    case 'NOV':
      return Array.from({ length: 30 }, (_, i) => (i < 9 ? `0${i + 1}` : (i + 1).toString()));
    case 'FEB':
      if ((yearNum % 4 === 0 && yearNum % 100 !== 0) || yearNum % 400 === 0) {
        return Array.from({ length: 29 }, (_, i) => (i < 9 ? `0${i + 1}` : (i + 1).toString()));
      }
      return Array.from({ length: 28 }, (_, i) => (i < 9 ? `0${i + 1}` : (i + 1).toString()));
    default:
      return [];
  }
};
